<script setup lang="ts">
import qs from 'qs';
import systemInfo from '@/stores/systemInfo';
import { checkUpdated } from '@utils/methods';
import { SYSTEM_INFO } from '@config/constant';
import { onLaunch, onShow, onReady } from '@dcloudio/uni-app';

const sysInfo = systemInfo();
const prjData = projectData();
const referralBindingStore = useReferralBindingStore();

sysInfo.$subscribe((_, state) =>
	uni.setStorage({
		key: SYSTEM_INFO,
		data: state,
	}),
);


















onLaunch(async ({ query }: any) => {
	// 先设置系统信息
	sysInfo.setSysData(query);
	// useMessage();
	prjData.fetchThumbResources();

	// 应用启动时尝试自动登录第一个账户（仅设置token，不触发API调用）
	setTimeout(() => {
		if (!sysInfo.token) {
			sysInfo.autoLoginFirstAccount();
		}
	}, 500);
});

// 页面准备就绪后
onReady(() => {
	// 延迟执行完整登录流程，确保API配置已初始化
	setTimeout(() => {
		console.log('执行完整登录流程');
		sysInfo.completeLogin();
	}, 1000);
});

onShow(({ query }: any) => {
	checkUpdated();
	referralBindingStore.setCode(query);

	if (query.scene) {
		let scene: any = decodeURIComponent(query.scene);
		scene = qs.parse(scene);
		referralBindingStore.setCode(scene);
	}

	// 页面显示时，如果没有token但有账户，尝试自动登录（仅设置token）
	if (!sysInfo.token) {
		sysInfo.autoLoginFirstAccount();
	} else {
		// 如果已有token，确保完整登录流程执行
		setTimeout(() => sysInfo.completeLogin(), 500);
	}
});
</script>

<style lang="scss">
@import '@climblee/uv-ui/index.scss';

@import '@zebra-ui/swiper/index.scss';
@import '@/assets/styles/public.scss';
@import '@/assets/styles/basic-form.scss';

</style>
